const PREDEFINED_COLORS = [
  { from: '#4F6DEE', to: '#67BDF9' },
  { from: '#38A04D', to: '#93DCA2' },
  { from: '#C35F2B', to: '#EDB395' },
  { from: '#633897', to: '#CBA1FF' },
];

function getStringHash(str: string): number {
  if (typeof str !== 'string') return 0;
  const normalized = str.trim().toLowerCase();
  let hash = 104729;
  const seed = 0x9747b28c;
  for (let i = 0; i < normalized.length; i++) {
    hash ^= seed ^ normalized.charCodeAt(i);
    hash = (hash << 13) | (hash >>> 19);
    hash = (hash * 5 + 0x52dce72d) | 0;
  }
  return Math.abs(hash);
}

/** 根据名称生成渐变背景 CSS 字符串（linear-gradient） */
export function getAppGradient(name: string): string {
  const { from, to } = PREDEFINED_COLORS[getStringHash(name) % PREDEFINED_COLORS.length];
  return `linear-gradient(to bottom, ${from}, ${to})`;
}

/** 取名称首字符并大写，用于无图时的头像文字 */
export function getAppInitial(name: string): string {
  return (name || '').charAt(0).toUpperCase();
}
